// removed by extract-text-webpack-plugin
module.exports = {"Box":"_1GugD","BoxActive":"_2rwxr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Filters/FilterButtonLarge/FilterButtonLarge.scss
// module id = 447
// module chunks = 0